import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../../Documentos/General'
import Aprobacion from '../../Documentos/Aprobacion'
import DocumentosAsociados from '../../Documentos/DocumentosAsociados'
import Entregas from '../../Documentos/Entregas'
import Adiciones from '../../Documentos/Adiciones'
import Facturas from '../../Documentos/Facturas'

import Cancelacion from '../../Documentos/Cancelacion'




import BoxButton from '../../Layout/BoxButton'
import ButtonStrip from '../../Layout/ButtonStrip'
import ModalCreateEntrega from '../../Documentos/ModalCreateEntrega'
import ModalAddFactura from '../../Documentos/ModalAddFactura'
import ModalLastFactura from '../../Documentos/ModalLastFactura'
import ModalAddAdicional from '../../Documentos/ModalAddAdicional'

import ModalSelectorFromList from '../../Shared/ModalSelectorFromList'

import {
    showHideModalAddAdicional,
    cancelDocumento,
    updateDocumento
} from '../../../actions/documentos'


import {
    showModalConfirmarAccion
} from '../../../actions/common'

import { isAllowedToViewComponent } from '../../../utils/helpers';

class Documento extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tabs: [

                { id: 0, caption: 'Documento', component: <General />, estado: 0 },
                { id: 1, caption: 'Aprobación', component: <Aprobacion />, estado: 0 },
                { id: 2, caption: 'Documentos asociados', component: <DocumentosAsociados />, estado: 1 },
                { id: 3, caption: 'Ajustes', component: <Adiciones />, estado: 0 },
                { id: 4, caption: 'Entregas', component: <Entregas />, estado: 0 },
                { id: 5, caption: 'Facturas', component: <Facturas />, estado: 6 },
                { id: 6, caption: 'Cancelación', component: <Cancelacion />, estado: 0 },
			],
			selected: 0
		}
	}



	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    
    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar este documento?`, () => { this.props.showModalConfirmarAccion(false); this.props.cancelDocumento()})
    }   

	render() {
		const { tabs, selected } = this.state
        const { documento, user, modalSummary } = this.props

        if (!documento) return null
        if (!documento.get('solicitude')) return null

        const editar = modalSummary.get('editar')

        let boxActions = []
        //if (selected === 2) boxActions = [ <BoxButton name="plus-circle" title="Asociar documento" onClick={ e => alert('hola') } />]


        if (selected === 6) boxActions = [ <BoxButton name="ban" title="Cancelar documento" onClick={ () => this.cancel() } disabled={ documento.get('estado') == 0} />]

        if (isAllowedToViewComponent('responsables_recibo', documento, user.get('id')) && (documento.get('estado') !== 11)) {
            if (selected === 3) boxActions = [ <BoxButton key='boxbtn[0]' name="plus-circle" title="Crear adición" onClick={ e => this.props.showHideModalAddAdicional(true, documento.get('id'), '', '') } />]
        }


        if (isAllowedToViewComponent('responsable_compras', documento.get('solicitude'))) {
            if (selected === 0) boxActions = [ <BoxButton key='boxbtn[1]' name="floppy-o" title="Actualizar documento" onClick={ () => this.props.updateDocumento() } disabled={ !editar } /> ]
        }
       

		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>

                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => x.estado <= documento.get('estado')).map(x => {

                                        if (documento.get('estado') == 11 && x.id == 6) return null

                                        return (
                                            <li key={ `li02[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )


                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div> 
                </div>
                <ModalCreateEntrega />
                <ModalAddFactura />
                <ModalLastFactura />
                <ModalAddAdicional />
                <ModalSelectorFromList />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        modalSummary: state.documentos.get('modalSummary'),
        user: state.common.get('user')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showHideModalAddAdicional: (show, documento, url, type) => dispatch(showHideModalAddAdicional(show, documento, url, type)),
        cancelDocumento: () => dispatch(cancelDocumento()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        updateDocumento: () => dispatch(updateDocumento()),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documento)


// WEBPACK FOOTER //
// ./src/components/BusquedaDocumento/Documento/index.jsx